import { filter } from "rxjs/operators";
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  DoCheck,
} from "@angular/core";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
  PopStateEvent,
} from "@angular/common";

import { NavbarComponent } from "../../components/navbar/navbar.component";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import { Subscription, Observable } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { NavbarService } from "../../components/navbar/navbar.service";

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"],
})
export class AdminLayoutComponent implements OnInit, DoCheck {
  private _router: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  isAuthenticated: boolean = true;
  isShowing;
  showFooter = true;

  constructor(
    public location: Location,
    private router: Router,
    private auth: AuthService,
    public nav: NavbarService
  ) {}

  ngOnInit() {
    this.isShowing = this.nav.showOrHide;
    this.updateFooterVisibility(this.router.url);
    /////////////// Checking access token //////////////////////////
    // const token = localStorage.getItem("access_token");
    // if (token) {
    //   this.isAuthenticated = !this.isAuthenticated;
    //   console.log(token);
    //   console.log(this.isAuthenticated);
    // }
    /////////////// Checking access token //////////////////////////

    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");

    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (event.url != this.lastPoppedUrl)
          this.yScrollStack.push(window.scrollY);
      } else if (event instanceof NavigationEnd) {
        this.updateFooterVisibility(event.urlAfterRedirects);
        if (event.url == this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else window.scrollTo(0, 0);
      }
    });
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        elemMainPanel.scrollTop = 0;
      });
  }

  private updateFooterVisibility(url: string): void {
    const routePath = (url || "").split("?")[0].split("#")[0];
    this.showFooter = !/^\/project\/[^/]+\/?$/.test(routePath);
  }

  ngDoCheck() {
    this.auth.isUserLoggedIn.subscribe((val) => {
      this.isAuthenticated = val;
    });
    // console.log(this.isAuthenticated);
    const token = localStorage.getItem("access_token");
    if (token) {
      this.isAuthenticated = true;
      // console.log(token);
      // console.log(this.isAuthenticated);
    }
  }

  ngAfterViewInit() {
    this.runOnRouteChange();
  }
  isMaps(path) {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    titlee = titlee.slice(1);
    if (path == titlee) {
      return false;
    } else {
      return true;
    }
  }
  runOnRouteChange(): void {
    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
    if (elemMainPanel) {
      elemMainPanel.scrollTop = 0;
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
}
